import Vapi from 'vuex-rest-api';

const tag = new Vapi({
  state: {
    tags: {},
  },
})
  .get({
    action: 'getTags',
    property: 'tags',
    path: () => '/api/fetcher/tags',
  })
  .getStore();

export default tag;
